module.exports = __webpack_public_path__ + "img/41_23.706582f9.png";